/* @ngInject */
const emailFields = (
  emailLabels,
  icons,
  types
) => {
  const self = {}

  self.email = {
    ref: 'email',
    label: emailLabels.fields.email.text,
    icon: icons.email,
    type: types.email,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  return self
}
export default emailFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/resources/fields.resource.js